"use strict";

import AxiosService from "../AxiosService";

const PLANNING = "/api/v1/addresses/planning"
const RESOURCE_PLANNING = "/api/v1/addresses/planned-resources"
const PLANNER_REMARK = "/api/v1/addresses/plannerRemark"

export default class PlanningService {
  constructor() {
    this.service = new AxiosService();
  }

  resolvePlannning() {
    return this.service.get(PLANNING);
  }

  resolveResourcePlanning() {
    return this.service.get(RESOURCE_PLANNING);
  }

  savePlannerRemark(uniqueIdAssignment, uniqueIdAddress, remark) {
    let payload = {
      "uniqueIdAssignment": uniqueIdAssignment,
      "uniqueIdAddress": uniqueIdAddress,
      "remark": remark,
    };
    return this.service.put(PLANNER_REMARK, payload);
  }
}
